import { DocumentsActions } from '@app/core/entities/actions';
import { getDocuments, getDocumentsLoading } from '@app/core/entities/reducers';
import { Document } from '@app/core/models/document';
import * as fromRoot from '@app/store/reducers';
import { TranslocoService } from '@jsverse/transloco';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

export abstract class DocumentsBaseComponent {
  documents$: Observable<Document[]>;
  isLoading$: Observable<boolean>;
  protected readonly store: Store<fromRoot.State>;
  protected readonly translocoService: TranslocoService;

  protected constructor(
    readonly storeParam: Store<fromRoot.State>,
    readonly translocoServiceParam: TranslocoService
  ) {
    this.store = storeParam;
    this.translocoService = translocoServiceParam;
    this.documents$ = this.store.select(getDocuments);
    this.isLoading$ = this.store.select(getDocumentsLoading);
  }

  downloadDocument(document: Document): void {
    this.store.dispatch(DocumentsActions.downloadDocument({ document }));
  }
}
